import * as tslib_1 from "tslib";
import { Vue, Component } from "vue-property-decorator";
import axios from "axios";
import { store } from "store";
import { isNotificationAllowed } from "common";
var UserStatisticsView = /** @class */ (function (_super) {
    tslib_1.__extends(UserStatisticsView, _super);
    function UserStatisticsView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.store = store;
        _this.sponsors = [];
        _this.remindersSent = false;
        _this.allOrganizations = [];
        // TODO: use mixin instead?
        _this.isNotificationAllowed = isNotificationAllowed;
        return _this;
    }
    UserStatisticsView.prototype.routed = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                // store.page.title = this.$t("userStatisticsView.title") as string;
                store.page.showTopNav = true;
                return [2 /*return*/];
            });
        });
    };
    /*
    get pendingSponsorCount(): number {
        return this.sponsorsOfStatus("Participates").length;
    }
    */
    UserStatisticsView.prototype.getSponsorsPaymentSum = function (sponsors) {
        var sum = sponsors
            .filter(function (s) { return s.participationStatus == "Paid"; })
            .reduce(function (sum, sponsor) { return sum + sponsor.paid; }, 0);
        return sum;
    };
    UserStatisticsView.prototype.getSponsorsEstimatedPayment = function (sponsors) {
        var sum = sponsors
            .filter(function (s) { return s.participationStatus == "Participates" || s.participationStatus == "Paid"; })
            .reduce(function (sum, sponsor) { return sum + sponsor.estimatedPayment; }, 0);
        return sum;
    };
    UserStatisticsView.prototype.sponsorsOfStatus = function (status) {
        return this.sponsors.filter(function (s) { return s.participationStatus == status; });
    };
    UserStatisticsView.prototype.remindPendingPaymentSponsors = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, _b, _c, sponsor, e_1_1, e_2;
            return tslib_1.__generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _d.trys.push([0, 9, , 10]);
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 6, 7, 8]);
                        _b = tslib_1.__values(this.sponsorsOfStatus("Participates")), _c = _b.next();
                        _d.label = 2;
                    case 2:
                        if (!!_c.done) return [3 /*break*/, 5];
                        sponsor = _c.value;
                        if (!isNotificationAllowed(sponsor)) return [3 /*break*/, 4];
                        return [4 /*yield*/, axios.post("sponsors/reminder-email", sponsor)];
                    case 3:
                        _d.sent();
                        // note: sponsor.notificationSentOn will be slightly out of sync with actual
                        // notificationSentOn stored in db until store is reloaded
                        sponsor.notificationSentOn = new Date(Date.now());
                        _d.label = 4;
                    case 4:
                        _c = _b.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_1_1 = _d.sent();
                        e_1 = { error: e_1_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                        }
                        finally { if (e_1) throw e_1.error; }
                        return [7 /*endfinally*/];
                    case 8:
                        this.remindersSent = true;
                        return [3 /*break*/, 10];
                    case 9:
                        e_2 = _d.sent();
                        return [3 /*break*/, 10];
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    UserStatisticsView = tslib_1.__decorate([
        Component
    ], UserStatisticsView);
    return UserStatisticsView;
}(Vue));
export default UserStatisticsView;
Vue.component("kk-user-statistics", UserStatisticsView);



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./app/ts/views/UserStatisticsView.vue
// module id = 74
// module chunks = 0